export type ApplicationId = string

export enum DevicePreviewEnum {
    DESKTOP = 'DESKTOP',
    MOBILE = 'MOBILE'
}

export enum DeviceEnum {
    DESKTOP = 'DESKTOP',
    MOBILE = 'MOBILE',
    TABLET = 'TABLET',
    CUSTOM = 'CUSTOM'
}

export type BreakPoint = {
    id: string
    icon: string
    name: string
    type: DevicePreviewEnum
    width: number
    device: DeviceEnum
}

export type AVPlayUrlResponse = {
    playUrl: string
    status: 'READY' | 'PROCESSING' | 'FAILED'
    expireAt: number
    message: string
}
